import { Range, Transaction } from 'types';

type CreateTransactionProps = {
  range: Range;
  transactionType: string;
  newFrom?: number;
  newTo?: number;
  newShareClass?: string;
};
export const createTransaction = ({
  range,
  transactionType,
  newFrom,
  newTo,
  newShareClass,
}: CreateTransactionProps): Transaction => ({
  partner: range.partner ?? '',
  shareFrom: range.from,
  shareTo: range.to,
  shareClass: range.shareClass ?? '',
  ...(range.sharePrice !== undefined && { sharePrice: range.sharePrice }),
  ...(range.sharePremium !== undefined && { sharePremium: range.sharePremium }),
  ...(newFrom !== undefined && { newShareFrom: newFrom }),
  ...(newTo !== undefined && { newShareTo: newTo }),
  ...(newShareClass !== undefined && { newShareClass }),
  transactionType,
});
